module.exports = __webpack_public_path__ + "static/img/5.b63d6aa.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/4/sp/5.png
// module id = u5ET
// module chunks = 0